module.exports = __webpack_public_path__ + "media/images/bank-logos-0816ecc37e9f4f7ee5e2f4707e557c6d.png";